import { combineReducers } from '@reduxjs/toolkit';
import catalogReducer from './catalog';
import lessonReducer from './lesson';
import lessonTaskReducer from './lessonTask';
import memberReducer from './member';
import requestingReducer from './requesting';
import userReducer from './user';

const sharedReducer = combineReducers({
  catalog: catalogReducer,
  lesson: lessonReducer,
  lessonTask: lessonTaskReducer,
  member: memberReducer,
  requesting: requestingReducer,
  user: userReducer
});

export default sharedReducer;
